import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const createLocationApprovalRequest = async (data) => {
  return await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/location-approval/create`,
    data,
  );
};

export const approveLocationApprovalRequest = async (data) => {
  return await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/location-approval/approve`,
    data,
  );
};

export const searchPendingLocationApprovalRequests = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/location-approval/search`,
    data,
  );
  return response.data;
};